import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class InAppBrowserProvider {
  constructor() {}

  open(url: string, targetStr: string, option: string, callback: () => void) {
    let browserWrap;
    let popup;
    let navigationButtonsDiv;
    let navigationButtonsDivInner;
    let backButton;
    let forwardButton;
    let closeButton;
    const strUrl = url;
    const target = targetStr;
    const features = option;

    if (target === "_inapp") {
      // "_blank" or anything else
      if (!browserWrap) {
        browserWrap = document.createElement("div");
        browserWrap.id = "in-app-browser-wrap";
        browserWrap.style.position = "absolute";
        browserWrap.style.top = "0";
        browserWrap.style.left = "0";
        browserWrap.style.boxSizing = "border-box";
        browserWrap.style.borderWidth = "40px";
        browserWrap.style.width = "100vw";
        browserWrap.style.height = "100vh";
        browserWrap.style.borderStyle = "solid";
        browserWrap.style.borderColor = "rgba(0,0,0,0.25)";
        browserWrap.style.backgroundColor = "white";

        // カスタマイズ
        browserWrap.style.borderWidth = "0px";
        browserWrap.style.height = "100vh";
        browserWrap.style.overflow = "auto";
        browserWrap.style.webkitOverflowScrolling = "touch";

        document.body.appendChild(browserWrap);
      }

      if (features.indexOf("hidden=yes") !== -1) {
        browserWrap.style.display = "none";
      }

      popup = document.createElement("iframe");
      popup.style.borderWidth = "0px";
      popup.style.width = "100%";
      popup.style.height = "100%";

      if (
        features.indexOf("location=yes") !== -1 ||
        features.indexOf("location") === -1
      ) {
        navigationButtonsDiv = document.createElement("div");
        navigationButtonsDiv.id = "navigation-buttons-div";
        navigationButtonsDiv.style.height = "60px";
        navigationButtonsDiv.style.backgroundColor = "#404040";
        navigationButtonsDiv.style.zIndex = "999";
        navigationButtonsDiv.onclick = (e: MouseEvent) => {
          e.cancelBubble = true;
        };

        navigationButtonsDivInner = document.createElement("div");
        navigationButtonsDivInner.style.paddingTop = "10px";
        navigationButtonsDivInner.style.height = "50px";
        navigationButtonsDivInner.style.width = "160px";
        navigationButtonsDivInner.style.margin = "0 auto";
        navigationButtonsDivInner.style.backgroundColor = "#404040";
        navigationButtonsDivInner.style.zIndex = "999";
        navigationButtonsDivInner.onclick = (e: MouseEvent) => {
          e.cancelBubble = true;
        };

        backButton = document.createElement("button");
        backButton.className = "back-button";
        backButton.style.width = "40px";
        backButton.style.height = "40px";
        backButton.style.borderRadius = "40px";

        backButton.innerHTML = "←";
        backButton.addEventListener("click", () => {
          if (popup.canGoBack) {
            popup.goBack();
          }
        });

        forwardButton = document.createElement("button");
        forwardButton.className = "forward-button";
        forwardButton.style.marginLeft = "20px";
        forwardButton.style.width = "40px";
        forwardButton.style.height = "40px";
        forwardButton.style.borderRadius = "40px";

        forwardButton.innerHTML = "→";
        forwardButton.addEventListener("click", () => {
          if (popup.canGoForward) {
            popup.goForward();
          }
        });

        closeButton = document.createElement("button");
        closeButton.id = "custom-in-app-browser";
        closeButton.style.marginLeft = "20px";
        closeButton.style.width = "40px";
        closeButton.style.height = "40px";
        closeButton.style.borderRadius = "40px";

        // カスタマイズ
        closeButton.style.marginLeft = "10px";
        closeButton.style.color = "white";
        closeButton.style.fontWeight = "bold";
        closeButton.style.fontSize = "32px";
        closeButton.style.position = "absolute";
        closeButton.style.top = "0";

        closeButton.innerHTML = "<span style='color:white'>×</span>";
        closeButton.addEventListener("click", () => {
          setTimeout(() => {
            this.close(browserWrap, popup, callback);
          }, 0);
        });

        // iframe navigation is not yet supported
        backButton.disabled = true;
        forwardButton.disabled = true;

        navigationButtonsDivInner.appendChild(backButton);
        navigationButtonsDivInner.appendChild(forwardButton);
        navigationButtonsDivInner.appendChild(closeButton);
        navigationButtonsDiv.appendChild(navigationButtonsDivInner);

        browserWrap.appendChild(closeButton);
      } else {
        popup.style.height = "100%";
      }

      browserWrap.appendChild(popup);
      popup.src = strUrl;
    }
  }

  close(browserWrap, popup, callback: () => void) {
    if (browserWrap) {
      if (browserWrap.parentNode) {
        browserWrap.parentNode.removeChild(browserWrap);
      }
      browserWrap = null;
      if (popup) {
        popup = null;
      }
      callback();
    }
  }
}
